import { useEffect } from 'react';
import useOverlay from 'hooks/use-overlay';
import { setUser } from 'actions/app_action';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from 'hooks/use-typed-selector';
import { User } from 'common/interfaces';
import { delay } from '../../utils/delay';
import useAvatarById from '../use-avatar-by-id';

const useSetUserInfoToRedux = () => {
  const dispatch = useDispatch();
  const user = useTypedSelector<User>(state => state['app'].user);
  const [_, hideOverlay] = useOverlay('initialUserData');
  const { getAvatarById } = useAvatarById();

  useEffect(() => {
    if (user.id) {
      const fetchAvatar = async () => {
        await delay(2000);
        const avatar = await getAvatarById(user.id);
        dispatch(
          setUser({
            ...user,
            avatar
          })
        );
      };

      fetchAvatar();
    }

    return hideOverlay;
  }, [user.id]);
};

export default useSetUserInfoToRedux;
